var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00032 9.35668L1.42243 5.72394C1.09693 5.39345 0.569624 5.39345 0.244125 5.72394C-0.0813749 6.05443 -0.0813749 6.58982 0.244125 6.92031L4.41052 11.1506C4.73602 11.4811 5.26333 11.4811 5.58883 11.1506L9.75522 6.92031C9.91928 6.75639 10 6.53959 10 6.32279C10 6.10599 9.91862 5.88971 9.75587 5.72473C9.43038 5.39424 8.90307 5.39424 8.57757 5.72473L5.00032 9.35668ZM5.00032 4.27904L1.42243 0.646304C1.09693 0.315815 0.569624 0.315815 0.244125 0.646304C-0.0813749 0.976793 -0.0813749 1.51219 0.244125 1.84268L4.41052 6.07294C4.73602 6.40343 5.26333 6.40343 5.58883 6.07294L9.75522 1.84268C9.91928 1.68007 10 1.46327 10 1.24647C10 1.02967 9.91862 0.8134 9.75587 0.64842C9.43038 0.317931 8.90307 0.317931 8.57757 0.64842L5.00032 4.27904Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentVideo);
export default __webpack_public_path__ + "static/media/currentVideo.725dcc08edcb0fbddcacd4144bcf313e.svg";
export { ForwardRef as ReactComponent };